import { Card, Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useEffect, useState } from "react";
import SoftTypography from "components/SoftTypography";
import PageTitle from "../../components/PageTitle";
import Loader from "examples/Loader";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { item } from "examples/Sidenav/styles/sidenavItem";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import { Update } from "@mui/icons-material";
import "../settingsCompact.css";

function DataMaping() {
  const AppService = useAppServices();
  const [agency, Update] = useAgencyInfo();
  const [loader, setLoader] = useState(true);
  const [customFields, setcustomFields] = useState([]);
  const [workflows, setworkflows] = useState([]);
  const GetCustomFields = async () => {
    const { response } = await AppService.agency.getworkflows({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setLoader(false);
      if (response.data?.customFields) {
        const temp_custom_fields = response.data?.customFields.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}-${item.fieldKey}`,
        }));
        setcustomFields(temp_custom_fields);
      }

     
      if (response?.workflows) {
        const temp_work_flows = response.workflows?.workflows.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}`,
        }));
        setworkflows(temp_work_flows);
      }
    } else {
      setLoader(false);
    }
  };
  const onLoad = () => {
    GetCustomFields();
  };
  useEffect(() => {
    onLoad();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const workflows = {
      user_created: e.target.user_created.value
    };

    const payload = {
      workflows: workflows,
      _id: agency._id,
    };
     
    const { response } = await AppService.agency.update({
      payload,
      toaster: true,
    });
    if (response) {
      Update(response.data);
    }
  };
  return (
    <SoftBox className="sd-settings">
      {loader ? (
        <Loader />
      ) : (
        <Card sx={{
          background: 'transparent',
          boxShadow: "none",
          borderRadius: 0
        }} role="form" component="form" onSubmit={handleSubmit}>
          <Card
            sx={{
              boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
              border: "1px solid #cfd7df",
              borderRadius: "8px",
              marginRight: "1em",
              overflow: "visible",
            }}
          >
            <SoftBox p={3} className="sd-page__header sd-page__header--in-card">
              <PageTitle card>Data Mapping</PageTitle>
            </SoftBox>
            <Grid container p={5} pt={0} rowSpacing={3} className="sd-page__body">
              <Grid item xs={12}>
                <SoftTypography variant="button" color="text" fontWeight="regular">
                  Which Custom field you want to store the user password
                </SoftTypography>
                <SoftSelect
                  defaultValue={
                    customFields.filter(
                      (item) => item.value == agency?.customFields?.["dashboard"]
                    )[0]
                  }
                  options={customFields}
                  placeholder="Select field"
                  name="dashboard"
                />
              </Grid>
              <Grid item xs={12} mt={3} display={"flex"} justifyContent={"flex-end"}>
                <SoftButton variant="outlined" color="dark" size="small" type="submit">
                  Save
                </SoftButton>
              </Grid>
            </Grid>
          </Card>


          <Card
            sx={{
              boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
              border: "1px solid #cfd7df",
              borderRadius: "8px",
              marginRight: "1em",
              overflow: "visible",
              marginTop: '30px'
            }}
          >
            <SoftBox p={3}>
              <SoftTypography variant="h5">Workflows</SoftTypography>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                To run the workflow for the actions.
              </SoftTypography>
            </SoftBox>
            <Grid container p={5} pt={0} rowSpacing={3}>
              <Grid item xs={12}>
                <SoftTypography variant="button" color="text" fontWeight="regular">
                  1- What Workflow You want to send when the user created?
                </SoftTypography>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  ml={2}
                  mb={1}
                  textTransform="capitalize"
                >
                  This workflow will send when you User is created.
                </SoftTypography>
                <SoftSelect
                  defaultValue={
                    workflows.filter(
                      (item) => item.value == agency?.customFields?.["user_created"]
                    )[0]
                  }
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select field"
                  name="user_created"
                />
              </Grid>
              {/* <Grid item xs={12}>
                <SoftTypography variant="button" color="text" fontWeight="regular">
                  6- Forum Topic Reply
                </SoftTypography>
                <SoftSelect
                  defaultValue={
                    workflows.filter(
                      (item) => item.value == agency?.customFields?.["assign_agent"]
                    )[0]
                  }
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select field"
                  name="assign_agent"
                />
              </Grid> */}
              <Grid item xs={12} mt={3} mb={5} pb={5} display={"flex"} justifyContent={"flex-end"}>
                <SoftButton variant="outlined" mb={5} color="dark" size="small" type="submit">
                  Save
                </SoftButton>
              </Grid>
            </Grid>
          </Card>
        </Card>
      )}
    </SoftBox>
  );
}

export default DataMaping;
